Object.defineProperty(exports,"__esModule",{value:true});var ENTER_PRESS='ENTER_PRESS';var SUGGESTION_SELECT='SUGGESTION_SELECT';var CLEAR_VALUE='CLEAR_VALUE';var causes={ENTER_PRESS:ENTER_PRESS,SUGGESTION_SELECT:SUGGESTION_SELECT,CLEAR_VALUE:CLEAR_VALUE};exports.default=causes;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@appbaseio/reactivecore/lib/utils/causes.js
// module id = ./node_modules/@appbaseio/reactivecore/lib/utils/causes.js
// module chunks = 0